<template>
  <div class="text-center">
    <v-dialog style="z-index:1000;" v-model="dialog" hide-overlay persistent width="1300">
      <v-card>
        <v-card-text v-if="loading">
          Φόρτωση
          <v-progress-linear
            indeterminate
            color="orange"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text v-if="!loading">
          <v-data-table
            dense
            :headers="tableHeader"
            :items="tableData"
            item-key="id"
            :items-per-page="pagination"
          >
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-btn text @click="dismissDialog" color="orange"> οκ </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => {
    return {
      internalDialog: true,
      loading: true,
      sensorEvents: [],
      pagination: 1000,
      isAdmin: false,
      displayNames: {
        id: "Αναγνωριστικό Συμβάντος",
        sensordescription: "Περιγραφή",
        sensorid: "Αναγνωριστικό Αισθητήρα",
        sensorindex: "Τύπος Συμβάντος",
        activity: "Κατάσταση",
        camp: "Περιοχή Ευθύνης",
        timestamp: "Χρονοσφραγίδα",
        confirmations: "Επικυρώσεις",
      },
    };
  },
  async created() {
    const query = { rawTimeBack: "01:00:00:00" }; //DD:HH:MM:SS
    let response = await this.$axios.get(`/sensorEvents/battery`, {
      params: { ...query },
    });
    this.sensorEvents = response.data;
    this.loading = false;
    console.log("Got battery events:");
    console.log(this.sensorEvents);
  },
  methods: {
    ...mapActions(["toggleBatteryDialogDismissedAction"]),
    dismissDialog() {
      this.dialog = false;
      this.toggleBatteryDialogDismissedAction();
    },
  },
  computed: {
    dialog: {
      // getter
      get: function () {
        console.log("Reading dialog:");
        console.log(this.internalDialog);
        return this.internalDialog;
      },
      // setter
      set: function (newValue) {
        this.internalDialog = newValue;
        console.log("Setting dialog:");
        console.log(this.internalDialog);
      },
    },
    tableHeader() {
      const self = this;
      if (!this.sensorEvents || this.sensorEvents.length == 0) {
        console.log("No battery events have been recorded yet...");
        if (!self.loading) {
          self.dialog = false;
          self.toggleBatteryDialogDismissedAction();
        }
        return [];
      }

      const ret = Object.keys(this.sensorEvents[0])
        .filter((x) => Object.keys(self.displayNames).includes(x.toLowerCase()))
        .map(function (x) {
          return {
            text: self.displayNames[x.toLowerCase()],
            align: "start",
            sortable: true,
            value: x,
          };
        });
      console.log("Found battery headers:");
      console.log(ret);
      return ret;
    },
    tableData() {
      let ret = this.sensorEvents.map(function (x) {
        var c = Object.assign({}, x);

        c.activity = x.activity ? "ON" : "OFF";
        var dt = new Date(x.timestamp);
        dt.setTime(dt.getTime() + 3 * 60 * 60 * 1000); // gmt + 3 offset, because timeZone on toLocaleString doesnt work
        c.timestamp = dt.toLocaleString("el-GR", { hour12: false });
        c.confirmations =
          x.confirmations == null || x.confirmations.length == 0
            ? "Καμία"
            : x.confirmations.length;

        const orientationMap = {
          0: "Νότια",
          1: "Βορειοδυτικά",
          2: "Βορειοανατολικά",
          3: "Χαμηλή Μπαταρία",
        };

        c.sensorIndex = orientationMap[c.sensorIndex];

        return c;
      });
      console.log("Found table data:");
      console.log(ret);
      return ret;
    },
  },
  //   watch: {
  //     dialog(val) {
  //       if (!val) return;

  //       setTimeout(() => (this.dialog = false), 4000);
  //     },
  //   },
};
</script>

<style>
</style>